import { useMutation, useQueryClient } from '@tanstack/react-query';
import { vehicleKeys, vehicleOptions } from '../../constants/vehicles';
export function useVehicleActions() {
    const queryClient = useQueryClient();
    const invalidateVehicles = () => queryClient.invalidateQueries({ queryKey: vehicleKeys.all });
    const getVehicles = async (filter, scope) => {
        return await queryClient.fetchQuery(vehicleOptions.get(filter, scope));
    };
    const createMutation = useMutation({ ...vehicleOptions.create(), onSuccess: invalidateVehicles });
    const updateMutation = useMutation({ ...vehicleOptions.update(), onSuccess: invalidateVehicles });
    const removeMutation = useMutation({ ...vehicleOptions.remove(), onSuccess: invalidateVehicles });
    const getOrCreateMutation = useMutation({ ...vehicleOptions.getOrCreate(), onSuccess: invalidateVehicles });
    return {
        getVehicles,
        createVehicle: createMutation.mutateAsync,
        updateVehicle: updateMutation.mutateAsync,
        removeVehicle: removeMutation.mutateAsync,
        getOrCreateVehicle: getOrCreateMutation.mutateAsync,
        savingVehicles: createMutation.isPending || updateMutation.isPending || removeMutation.isPending || getOrCreateMutation.isPending,
    };
}
